<template>
<div class="edit-menu-page">
    <!-- Top Header Navigation -->
    <header class="sci-header">
        <div class="header-content">
            <div class="header-left">
                <button type="button" class="sci-btn sci-btn-ghost btn-back" @click.prevent="home" title="Torna al Gestionale">
                    <i class="fas fa-arrow-left me-2"></i>{{ $t('home') }}
                </button>
                <div class="header-title-box">
                    <h2 class="header-title">
                        <i class="fas fa-book-open text-primary me-2"></i>{{ $t('aggiungi_modifica_piatti') }}
                    </h2>
                    <span class="header-badge">{{ filteredPiatti.length }} / {{ piatti.length }} {{ $t('piatti', 'piatti') }}</span>
                </div>
            </div>
            <div class="header-actions">
                <button type="button" class="sci-btn sci-btn-primary" @click="clearData">
                    <i class="fas fa-plus me-2"></i>Nuovo Piatto
                </button>
            </div>
        </div>
    </header>

    <!-- Modals Backdrop -->
    <div class="sci-modal-backdrop" v-if="showAggiunte || showSenza || showErrorModal" @click="closeModals"></div>

    <!-- Modal Aggiunte Possibili -->
    <div class="sci-modal" v-if="showAggiunte" role="dialog" aria-modal="true">
        <div class="sci-modal-dialog">
            <div class="sci-modal-card">
                <div class="sci-modal-header">
                    <div>
                        <h4 class="mb-0 fw-bold text-dark"><i class="fas fa-plus-circle text-primary me-2"></i>{{ $t('aggiunte_possibili') }}</h4>
                        <small class="text-muted">Seleziona le varianti o supplementi applicabili a questo piatto</small>
                    </div>
                    <button type="button" class="sci-btn-close" @click="showAggiunte = false">&times;</button>
                </div>
                <div class="sci-modal-search">
                    <i class="fas fa-search search-icon"></i>
                    <input type="text" v-model="searchAggiunte" placeholder="Cerca aggiunta tra i prodotti..." class="sci-input search-input" />
                </div>
                <div class="sci-modal-body">
                    <div class="touch-option-grid">
                        <label v-for="(prodotto, index) in filteredModalAggiunte" :key="'edit_add_k_' + (prodotto.code || prodotto.descrizio || index)" class="touch-option-card" :class="{ 'is-checked': isAddChecked(prodotto) }">
                            <input type="checkbox" class="sci-checkbox" :id="'edit_add_' + index" :name="prodotto.code" :checked="isAddChecked(prodotto)" @change="toggleAdd(prodotto)">
                            <div class="option-details">
                                <span class="option-name">{{prodotto.descrizio || prodotto.nome}}</span>
                                <span class="option-price" v-if="prodotto.prezzoAggiunta">+€{{ Number(prodotto.prezzoAggiunta).toFixed(2) }}</span>
                            </div>
                        </label>
                    </div>
                </div>
                <div class="sci-modal-footer">
                    <button type="button" class="sci-btn sci-btn-primary w-100" @click="showAggiunte = false">
                        <i class="fas fa-check me-2"></i>Conferma Selezioni ({{ add.length }})
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal Senza (Ingredienti Rimovibili) -->
    <div class="sci-modal" v-if="showSenza" role="dialog" aria-modal="true">
        <div class="sci-modal-dialog">
            <div class="sci-modal-card">
                <div class="sci-modal-header">
                    <div>
                        <h4 class="mb-0 fw-bold text-dark"><i class="fas fa-minus-circle text-danger me-2"></i>{{ $t('possono_togliere') }}</h4>
                        <small class="text-muted">Seleziona gli ingredienti che il cliente può richiedere di omettere</small>
                    </div>
                    <button type="button" class="sci-btn-close" @click="showSenza = false">&times;</button>
                </div>
                <div class="sci-modal-search">
                    <i class="fas fa-search search-icon"></i>
                    <input type="text" v-model="searchSenza" placeholder="Cerca ingrediente da omettere..." class="sci-input search-input" />
                </div>
                <div class="sci-modal-body">
                    <div class="touch-option-grid">
                        <label v-for="(prodotto, index) in filteredModalSenza" :key="'edit_rem_k_' + (prodotto.descrizio || index)" class="touch-option-card is-minus" :class="{ 'is-checked': isMinusChecked(prodotto) }">
                            <input type="checkbox" class="sci-checkbox" :id="'edit_minus_' + index" :name="prodotto.descrizio" :checked="isMinusChecked(prodotto)" @change="toggleMinus(prodotto)">
                            <div class="option-details">
                                <span class="option-name">{{prodotto.descrizio || prodotto.nome}}</span>
                            </div>
                        </label>
                    </div>
                </div>
                <div class="sci-modal-footer">
                    <button type="button" class="sci-btn sci-btn-primary w-100" @click="showSenza = false">
                        <i class="fas fa-check me-2"></i>Conferma Ingredienti Rimovibili ({{ minus.length }})
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Error / Alert Modal -->
    <div class="sci-modal" v-if="showErrorModal" role="dialog" aria-modal="true">
        <div class="sci-modal-dialog" style="max-width: 480px;">
            <div class="sci-modal-card">
                <div class="sci-modal-header bg-danger-subtle border-0">
                    <h5 class="modal-title text-danger fw-bold"><i class="fas fa-exclamation-triangle me-2"></i>Attenzione</h5>
                    <button type="button" class="sci-btn-close" @click="showErrorModal = false">&times;</button>
                </div>
                <div class="sci-modal-body text-center py-4">
                    <p class="fs-6 mb-0 text-dark fw-medium">{{ errorModalMessage }}</p>
                </div>
                <div class="sci-modal-footer">
                    <button type="button" class="sci-btn sci-btn-secondary w-100" @click="showErrorModal = false">Ho capito</button>
                </div>
            </div>
        </div>
    </div>

    <!-- Main Container Layout -->
    <div class="main-container">
        <!-- Hick-Hyman Filter & Search Bar -->
        <div class="filter-controls-bar">
            <div class="category-pills">
                <button 
                    type="button" 
                    class="category-pill" 
                    :class="{ active: filtroPortata === 'tutte' }"
                    @click="filtroPortata = 'tutte'"
                >
                    Tutti ({{ piatti.length }})
                </button>
                <button 
                    v-for="cat in availableCategories" 
                    :key="cat.value" 
                    type="button" 
                    class="category-pill" 
                    :class="{ active: filtroPortata.toLowerCase() === cat.value.toLowerCase() }"
                    @click="filtroPortata = cat.value"
                >
                    {{ cat.label }} ({{ countCategory(cat.value) }})
                </button>
            </div>
            <div class="search-box">
                <i class="fas fa-search search-icon"></i>
                <input 
                    type="text" 
                    v-model="searchQuery" 
                    placeholder="Cerca piatto per nome o ingredienti..." 
                    class="sci-input search-input" 
                />
                <button v-if="searchQuery" type="button" class="clear-search" @click="searchQuery = ''">&times;</button>
            </div>
        </div>

        <!-- Bento Grid: Dishes Catalogue (Left) & Editor Card (Right) -->
        <div class="bento-menu-grid">
            <!-- Left: Dishes Catalogue -->
            <div class="catalogue-column">
                <div class="sci-card catalogue-card">
                    <div class="card-header-bar">
                        <h4 class="card-title">
                            <i class="fas fa-utensils text-primary me-2"></i>Elenco Portate & Piatti
                        </h4>
                        <span class="text-muted small">Clicca su una riga per caricarla nel form di modifica</span>
                    </div>

                    <div v-if="filteredPiatti.length === 0" class="empty-state">
                        <i class="fas fa-utensils empty-icon"></i>
                        <h5>Nessun piatto trovato</h5>
                        <p class="text-muted">Nessun elemento corrisponde ai filtri selezionati.</p>
                        <button type="button" class="sci-btn sci-btn-secondary btn-sm" @click="filtroPortata = 'tutte'; searchQuery = ''">
                            Reimposta filtri
                        </button>
                    </div>

                    <div v-else class="table-responsive">
                        <table class="sci-table">
                            <thead>
                                <tr>
                                    <th style="width: 60px;">Foto</th>
                                    <th>{{ $t('nome') }}</th>
                                    <th>{{ $t('portata') }}</th>
                                    <th>{{ $t('prezzo') }}</th>
                                    <th>Modifiche</th>
                                    <th style="width: 90px; text-align: right;">Azioni</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr 
                                    v-for="piattoItem in filteredPiatti" 
                                    :key="piattoItem.nome" 
                                    class="dish-row"
                                    :class="{ 'is-selected': modifica === piattoItem.nome, 'is-hidden-dish': piattoItem.nascondi }"
                                    @click="update(piattoItem)"
                                >
                                    <!-- Photo Thumbnail -->
                                    <td>
                                        <div class="dish-thumb-box">
                                            <img 
                                                v-if="piattoItem.immagine" 
                                                :src="store.path.split('/api')[0] + '/' + piattoItem.immagine" 
                                                alt="Foto piatto" 
                                                class="dish-thumb-img" 
                                            />
                                            <div v-else class="dish-thumb-placeholder">
                                                <i class="fas fa-utensils"></i>
                                            </div>
                                        </div>
                                    </td>

                                    <!-- Name & Description -->
                                    <td>
                                        <div class="dish-name-cell">
                                            <strong class="dish-name-text">{{ piattoItem.nome }}</strong>
                                            <span v-if="piattoItem.nascondi" class="badge-hidden ms-2">NASCOSTO</span>
                                            <div v-if="piattoItem.descrizione" class="dish-desc-text text-truncate" :title="piattoItem.descrizione">
                                                {{ piattoItem.descrizione }}
                                            </div>
                                        </div>
                                    </td>

                                    <!-- Category / Portata -->
                                    <td>
                                        <span class="badge-portata" :class="'portata-' + (piattoItem.portata || '').toLowerCase()">
                                            {{ piattoItem.portata || 'Generale' }}
                                        </span>
                                    </td>

                                    <!-- Price -->
                                    <td>
                                        <span class="price-tag">€ {{ Number(piattoItem.prezzo || 0).toFixed(2) }}</span>
                                    </td>

                                    <!-- Aggiunte & Senza -->
                                    <td>
                                        <div class="variations-summary">
                                            <span v-if="piattoItem.addProd && piattoItem.addProd.length" class="var-badge var-add" :title="piattoItem.addProd.map(formatVariante).join(', ')">
                                                +{{ piattoItem.addProd.length }} agg.
                                            </span>
                                            <span v-if="piattoItem.removeProd && piattoItem.removeProd.length" class="var-badge var-remove ms-1" :title="piattoItem.removeProd.map(formatVariante).join(', ')">
                                                -{{ piattoItem.removeProd.length }} senza
                                            </span>
                                            <span v-if="(!piattoItem.addProd || !piattoItem.addProd.length) && (!piattoItem.removeProd || !piattoItem.removeProd.length)" class="text-muted small">
                                                —
                                            </span>
                                        </div>
                                    </td>

                                    <!-- Quick Actions -->
                                    <td style="text-align: right;">
                                        <button 
                                            type="button" 
                                            class="sci-btn sci-btn-ghost btn-sm btn-icon" 
                                            @click.stop="update(piattoItem)" 
                                            title="Modifica questo piatto"
                                        >
                                            <i class="fas fa-pencil-alt text-primary"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <!-- Right: Sticky Editor Form Card -->
            <div class="editor-column">
                <div class="sci-card editor-card">
                    <div class="editor-card-header">
                        <div class="d-flex align-items-center justify-content-between">
                            <h4 class="card-title mb-0">
                                <i :class="modifica ? 'fas fa-edit text-primary' : 'fas fa-plus-circle text-success'" class="me-2"></i>
                                {{ modifica ? 'Modifica Piatto' : 'Nuovo Piatto' }}
                            </h4>
                            <span v-if="modifica" class="badge bg-primary text-white">In Modifica</span>
                        </div>
                        <small class="text-muted" v-if="modifica">Stai modificando <strong>{{ modifica }}</strong></small>
                    </div>

                    <form @submit.prevent="updateMenu" class="editor-form">
                        <!-- Portata Selector -->
                        <div class="form-group-sci">
                            <label class="form-label-sci">{{ $t('portata') }} <span class="text-danger">*</span></label>
                            <select v-model="portata" class="sci-input sci-select" required>
                                <option value="" disabled selected>-- Seleziona portata --</option>
                                <option value="antipasti">Antipasti</option>
                                <option value="primi">Primi</option>
                                <option value="secondi">Secondi</option>
                                <option value="contorni">Contorni</option>
                                <option value="pizza">Pizza</option>
                                <option value="sushi">Sushi</option>
                                <option value="dolci">Dolci</option>
                                <option value="frutta">Frutta</option>
                                <option value="bevande">Bevande</option>
                                <option value="caffe">Caffè</option>
                                <option value="amari">Amari</option>
                            </select>
                        </div>

                        <!-- Dish Name -->
                        <div class="form-group-sci">
                            <label class="form-label-sci">{{ $t('nome_piatto') }} <span class="text-danger">*</span></label>
                            <input 
                                type="text" 
                                v-model="piatto" 
                                class="sci-input" 
                                placeholder="Es: Carbonara Tradizionale" 
                                required 
                            />
                        </div>

                        <!-- Price -->
                        <div class="form-group-sci">
                            <label class="form-label-sci">{{ $t('prezzo_euro') }} <span class="text-danger">*</span></label>
                            <div class="input-with-addon">
                                <span class="input-addon">€</span>
                                <input 
                                    type="number" 
                                    step="0.10" 
                                    min="0" 
                                    v-model="prezzo" 
                                    class="sci-input" 
                                    placeholder="0.00" 
                                    required 
                                />
                            </div>
                        </div>

                        <!-- Description -->
                        <div class="form-group-sci">
                            <label class="form-label-sci">{{ $t('descrizione') }}</label>
                            <textarea 
                                v-model="descrizione" 
                                class="sci-input sci-textarea" 
                                rows="3" 
                                placeholder="Ingredienti principali, allergeni, note culinarie..."
                            ></textarea>
                        </div>

                        <!-- Visibility Switch -->
                        <div class="switch-box-sci">
                            <label class="switch-sci">
                                <input type="checkbox" id="nascondiPiatto" v-model="nascondi" />
                                <span class="slider-sci"></span>
                            </label>
                            <label for="nascondiPiatto" class="switch-label-sci">
                                <strong>{{ $t('nascondi_piatto') || 'Nascondi piatto' }}</strong>
                                <small class="d-block text-muted">Se attivo, il piatto non apparirà nel menù digitale dei clienti</small>
                            </label>
                        </div>

                        <!-- Photo Upload & Preview -->
                        <div class="form-group-sci">
                            <label class="form-label-sci">Foto Piatto</label>
                            <div v-if="immagine" class="image-preview-card">
                                <img :src="store.path.split('/api')[0] + '/' + immagine" alt="Foto piatto" class="preview-img" />
                                <button type="button" class="btn-remove-photo" @click="immagine = ''" title="Rimuovi foto">&times;</button>
                            </div>
                            <div class="photo-upload-zone" @click="$refs.photoFileInput.click()">
                                <i class="fas fa-camera upload-icon"></i>
                                <span class="upload-text">{{ immagine ? 'Sostituisci foto' : 'Scatta o carica foto piatto' }}</span>
                                <input 
                                    type="file" 
                                    ref="photoFileInput" 
                                    accept="image/*" 
                                    capture="environment" 
                                    @change="onImageSelected" 
                                    style="display: none;" 
                                />
                            </div>
                        </div>

                        <!-- Variations Buttons (Shannon-Fitts Target Pairs) -->
                        <div class="variations-actions-grid">
                            <button type="button" class="sci-btn sci-btn-outline-primary" @click="showAggiunte = true">
                                <i class="fas fa-plus-circle me-1"></i>{{ $t('aggiunte') }}
                                <span class="badge bg-primary ms-1" v-if="add.length">{{ add.length }}</span>
                            </button>
                            <button type="button" class="sci-btn sci-btn-outline-danger" @click="showSenza = true">
                                <i class="fas fa-minus-circle me-1"></i>{{ $t('senza') }}
                                <span class="badge bg-danger ms-1" v-if="minus.length">{{ minus.length }}</span>
                            </button>
                        </div>

                        <!-- Primary Fitts's Law Actions -->
                        <div class="editor-actions-stack">
                            <button type="submit" class="sci-btn sci-btn-primary btn-save w-100">
                                <i class="fas fa-save me-2"></i>{{ buttonText }}
                            </button>
                            <div class="d-flex gap-2" v-if="modifica">
                                <button type="button" class="sci-btn sci-btn-danger flex-grow-1" @click="eliminaPiatto">
                                    <i class="fas fa-trash-alt me-1"></i>{{ $t('elimina_piatto') }}
                                </button>
                                <button type="button" class="sci-btn sci-btn-secondary" @click="clearData">
                                    <i class="fas fa-times me-1"></i>{{ $t('deseleziona') }}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { store } from '../store/store.js'

export default {
  name: 'EditMenu',
  data: function(){
      return {
          piatti: [],
          modifica: '',
          buttonText: 'Aggiungi',
          piatto: '',
          prezzo: '',
          descrizione: '',
          immagine: '',
          portata: '',
          prodotti: [],
          add: [],
          minus: [],
          picked: '',
          addPrice: [],
          showAggiunte: false,
          showSenza: false,
          showErrorModal: false,
          errorModalMessage: '',
          store,
          nascondi: false,
          searchQuery: '',
          filtroPortata: 'tutte',
          searchAggiunte: '',
          searchSenza: '',
          availableCategories: [
              { value: 'antipasti', label: 'Antipasti' },
              { value: 'primi', label: 'Primi' },
              { value: 'secondi', label: 'Secondi' },
              { value: 'contorni', label: 'Contorni' },
              { value: 'pizza', label: 'Pizza' },
              { value: 'sushi', label: 'Sushi' },
              { value: 'dolci', label: 'Dolci' },
              { value: 'frutta', label: 'Frutta' },
              { value: 'bevande', label: 'Bevande' },
              { value: 'caffe', label: 'Caffè' },
              { value: 'amari', label: 'Amari' }
          ]
      }
  },
  computed: {
      filteredPiatti() {
          let list = this.piatti || [];
          if (this.filtroPortata && this.filtroPortata !== 'tutte') {
              const cat = this.filtroPortata.trim().toLowerCase();
              list = list.filter(p => (p.portata || '').trim().toLowerCase() === cat);
          }
          if (this.searchQuery && this.searchQuery.trim()) {
              const q = this.searchQuery.trim().toLowerCase();
              list = list.filter(p => 
                  (p.nome || '').toLowerCase().includes(q) || 
                  (p.descrizione || '').toLowerCase().includes(q) ||
                  (p.portata || '').toLowerCase().includes(q)
              );
          }
          return list;
      },
      filteredModalAggiunte() {
          const list = this.prodotti || [];
          if (!this.searchAggiunte || !this.searchAggiunte.trim()) return list;
          const q = this.searchAggiunte.trim().toLowerCase();
          return list.filter(p => (p.descrizio || p.nome || '').toLowerCase().includes(q));
      },
      filteredModalSenza() {
          const list = this.prodotti || [];
          if (!this.searchSenza || !this.searchSenza.trim()) return list;
          const q = this.searchSenza.trim().toLowerCase();
          return list.filter(p => (p.descrizio || p.nome || '').toLowerCase().includes(q));
      },
      aggiornaButton(){
          if (this.modifica) {
              return this.$t('modifica') || 'Salva Modifiche';
          } else {
              return this.$t('aggiungi') || 'Aggiungi Piatto';
          }
      }
  },
  watch: {
      aggiornaButton: {
          immediate: true,
          handler: function(val){
              this.buttonText = val; 
          }
      }
  },
  methods: {
    countCategory(cat) {
        if (!this.piatti || !this.piatti.length) return 0;
        const c = String(cat).toLowerCase();
        return this.piatti.filter(p => (p.portata || '').toLowerCase() === c).length;
    },
    closeModals() {
        this.showAggiunte = false;
        this.showSenza = false;
        this.showErrorModal = false;
    },
    home() {
        this.$router.push({ name: "Gestionale" });
    },
    updateMenu() {
        const mancano = [];
        if (!this.piatto || !this.piatto.trim()) {
            mancano.push('il nome');
        }
        if (!this.portata || !this.portata.trim()) {
            mancano.push('la portata');
        }

        if (mancano.length > 0) {
            this.errorModalMessage = `Impossibile salvare il piatto: manca ${mancano.join(' e ')}.`;
            this.showErrorModal = true;
            return;
        }

        this.addPrice = [];
        this.add.forEach(element => {
            const desc = typeof element === 'object' ? (element.descrizione || element.nome) : element;
            const code = typeof element === 'object' ? (element.prodottoId || element.code) : null;
            const price = this.prodotti.find(o => (code && o.code === code) || o.descrizio === desc || o.nome === desc);
            if(price) {
                this.addPrice.push({ nome: price.nome || price.descrizio, prezzo: price['prezzoAggiunta'] ? price['prezzoAggiunta'] : 0 });
            }
        });

        const payload = {
            nome: this.piatto,
            prezzo: this.prezzo,
            descrizione: this.descrizione,
            portata: this.portata,
            addProd: this.add,
            removeProd: this.minus,
            addPrice: this.addPrice,
            nascondi: this.nascondi
        };

        if (this.immagine && !this.immagine.startsWith('http')) {
            payload.immagine = this.immagine;
        }

        this.axios.post(this.store.path + `update`, payload, {
            headers: {
                authorization: `Bearer ${JSON.parse(localStorage.token)}`
            }
        }).then((response) => {
            if (response.data) {
                this.displayMenu();
                this.clearData();
            }
        }).catch((err) => {
            console.error("Errore nell'aggiornamento del menu:", err);
            this.errorModalMessage = "Errore durante il salvataggio del piatto.";
            this.showErrorModal = true;
        });
    },
    eliminaPiatto() {
        const passwordAdmin = prompt("Inserisci la password amministratore per eliminare il piatto:");
        if (passwordAdmin === null) return;

        this.axios.post(this.store.path + `rimuoviPiatto`, { 
            nome: this.piatto, 
            portata: this.portata,
            passwordAdmin: passwordAdmin
        }, {
            headers: {
                authorization: `Bearer ${JSON.parse(localStorage.token)}`
            }
        }).then((response) => {
            if (response.data) {
                this.displayMenu();
                this.clearData();
            }
        }).catch((error) => {
            console.error("Errore durante l'eliminazione:", error);
            const msg = error.response?.data?.messaggio || "Errore durante l'eliminazione del piatto.";
            alert(msg);
        });
    },
    update(target) {
        let nomePiatto = '';
        if (target && typeof target === 'object' && target.nome) {
            nomePiatto = target.nome;
        } else if (target && target.target) {
            nomePiatto = target.target.innerText || target.target.innerHTML;
        } else if (typeof target === 'string') {
            nomePiatto = target;
        }
        nomePiatto = (nomePiatto || '').trim();
        const found = this.piatti.find(p => p.nome === nomePiatto);
        if (found) {
            this.modifica = found.nome;
            this.piatto = found.nome;
            this.prezzo = found.prezzo;
            this.descrizione = found.descrizione || '';
            this.immagine = found.immagine || '';
            this.portata = found.portata;
            this.add = found.addProd ? JSON.parse(JSON.stringify(found.addProd)) : [];
            this.minus = found.removeProd ? JSON.parse(JSON.stringify(found.removeProd)) : [];
            this.nascondi = found.nascondi || false;

            // Scroll editor into view on mobile
            if (window.innerWidth < 992) {
                const editorEl = document.querySelector('.editor-column');
                if (editorEl) editorEl.scrollIntoView({ behavior: 'smooth' });
            }
        }
    },
    formatVariante(variante) {
        if (!variante) return '';
        let item = variante;
        if (typeof item === 'string' && item.trim().startsWith('{')) {
            try { item = JSON.parse(item); } catch (err) { void err; }
        }
        if (typeof item === 'object' && item !== null) {
            return item.descrizione || item.nome || item.descrizio || String(variante);
        }
        return String(item);
    },
    isAddChecked(prodotto) {
        if (!this.add || !this.add.length || !prodotto) return false;
        const pCode = String(prodotto.code || prodotto._id || '');
        const pDesc = String(prodotto.descrizio || prodotto.nome || '').trim().toLowerCase();

        return this.add.some(a => {
            if (!a) return false;
            let item = a;
            if (typeof item === 'string' && item.trim().startsWith('{')) {
                try { item = JSON.parse(item); } catch (err) { void err; }
            }
            if (typeof item === 'string') {
                return String(item).trim().toLowerCase() === pDesc;
            }
            const aCode = String(item.prodottoId || item.code || item._id || '');
            const aDesc = String(item.descrizione || item.descrizio || item.nome || '').trim().toLowerCase();
            return (pCode && aCode && pCode === aCode) || (pDesc && aDesc && pDesc === aDesc);
        });
    },
    toggleAdd(prodotto) {
        if (!prodotto) return;
        const pCode = String(prodotto.code || prodotto._id || '');
        const pDesc = String(prodotto.descrizio || prodotto.nome || '').trim().toLowerCase();

        const idx = this.add.findIndex(a => {
            if (!a) return false;
            let item = a;
            if (typeof item === 'string' && item.trim().startsWith('{')) {
                try { item = JSON.parse(item); } catch (err) { void err; }
            }
            if (typeof item === 'string') {
                return String(item).trim().toLowerCase() === pDesc;
            }
            const aCode = String(item.prodottoId || item.code || item._id || '');
            const aDesc = String(item.descrizione || item.descrizio || item.nome || '').trim().toLowerCase();
            return (pCode && aCode && pCode === aCode) || (pDesc && aDesc && pDesc === aDesc);
        });

        if (idx >= 0) {
            this.add.splice(idx, 1);
        } else {
            this.add.push({ prodottoId: prodotto.code, descrizione: prodotto.descrizio });
        }
    },
    isMinusChecked(prodotto) {
        if (!this.minus || !this.minus.length || !prodotto) return false;
        const pDesc = String(prodotto.descrizio || prodotto.nome || '').trim().toLowerCase();
        return this.minus.some(m => {
            let item = m;
            if (typeof item === 'string' && item.trim().startsWith('{')) {
                try { item = JSON.parse(item); } catch (err) { void err; }
            }
            const mDesc = typeof item === 'object' ? String(item.descrizione || item.nome || item.descrizio || '') : String(item);
            return mDesc.trim().toLowerCase() === pDesc;
        });
    },
    toggleMinus(prodotto) {
        if (!prodotto) return;
        const pDescStr = prodotto.descrizio || prodotto.nome || '';
        const pDesc = pDescStr.trim().toLowerCase();
        const idx = this.minus.findIndex(m => {
            let item = m;
            if (typeof item === 'string' && item.trim().startsWith('{')) {
                try { item = JSON.parse(item); } catch (err) { void err; }
            }
            const mDesc = typeof item === 'object' ? String(item.descrizione || item.nome || item.descrizio || '') : String(item);
            return mDesc.trim().toLowerCase() === pDesc;
        });
        if (idx >= 0) {
            this.minus.splice(idx, 1);
        } else {
            this.minus.push(pDescStr);
        }
    },
    clearData(){
        this.piatto = '';
        this.prezzo = '';
        this.modifica = '';
        this.descrizione = '';
        this.immagine = '';
        this.add = [];
        this.minus = [];
        this.addPrice = [];
        this.nascondi = false;
    },
    async onImageSelected(event) {
        if (event.target.files.length === 0) return;
        const file = event.target.files[0];
        const formData = new FormData();
        formData.append('file', file);
        try {
            const response = await this.axios.post(this.store.path + 'uploadImg', formData);
            if (response.data.filename) {
                this.immagine = response.data.filename;
            }
        } catch (error) {
            console.error(error);
            alert("Errore durante il caricamento dell'immagine.");
        }
    },
    displayMenu() {
        this.axios.post(this.store.path+'displayMenu',{
            isAdminShowAll: true,
            headers:{
                authorization: `Bearer ${JSON.parse(localStorage.token)}`
            }
        }).then((response) => {
            if(response.data.messaggio){
                this.piatti = response.data.messaggio;
            }
        }).catch(err => console.error("Errore caricamento menu:", err));
    },
    displayProduct() {
        this.axios.post(this.store.path+'displayProduct',{headers:{
            authorization: `Bearer ${JSON.parse(localStorage.token)}`
        }}).then((response) => {
            if(response.data.messaggio){
                this.prodotti = response.data.messaggio;
            }
        }).catch(err => console.error("Errore caricamento prodotti:", err));
    }
  },
  beforeMount() {
      this.displayMenu();
      this.displayProduct();
  }
}
</script>

<style scoped>
.edit-menu-page {
    min-height: 100vh;
    background-color: var(--sci-bg);
    padding-bottom: 60px;
}

/* Header */
.sci-header {
    background: var(--sci-surface-glass);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border-bottom: 1px solid var(--sci-border);
    position: sticky;
    top: 0;
    z-index: 100;
    padding: 14px 24px;
}

.header-content {
    max-width: 1440px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
}

.header-left {
    display: flex;
    align-items: center;
    gap: 16px;
}

.header-title-box {
    display: flex;
    align-items: center;
    gap: 12px;
}

.header-title {
    font-size: 1.35rem;
    font-weight: 800;
    color: var(--sci-text-main);
    margin: 0;
    letter-spacing: -0.02em;
}

.header-badge {
    background: var(--sci-primary-subtle);
    color: var(--sci-primary);
    font-size: 0.75rem;
    font-weight: 700;
    padding: 4px 10px;
    border-radius: var(--radius-full);
    border: 1px solid var(--sci-primary-border);
}

/* Main Layout */
.main-container {
    max-width: 1440px;
    margin: 24px auto 0 auto;
    padding: 0 20px;
}

/* Filter Controls Bar */
.filter-controls-bar {
    background: var(--sci-surface);
    border: 1px solid var(--sci-border);
    border-radius: var(--radius-lg);
    padding: 12px 16px;
    margin-bottom: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
    box-shadow: var(--shadow-xs);
}

.category-pills {
    display: flex;
    gap: 8px;
    overflow-x: auto;
    padding-bottom: 4px;
    max-width: 100%;
}

.category-pill {
    background: var(--sci-bg-subtle);
    color: var(--sci-text-muted);
    border: 1px solid transparent;
    padding: 6px 14px;
    border-radius: var(--radius-full);
    font-size: 0.85rem;
    font-weight: 600;
    white-space: nowrap;
    cursor: pointer;
    transition: all 0.2s ease;
}

.category-pill:hover {
    background: #e2e8f0;
    color: var(--sci-text-main);
}

.category-pill.active {
    background: var(--sci-primary);
    color: #ffffff;
    box-shadow: 0 2px 6px rgba(79, 70, 229, 0.3);
}

.search-box {
    position: relative;
    min-width: 280px;
    flex: 1;
    max-width: 360px;
}

.search-icon {
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--sci-text-subtle);
    font-size: 0.9rem;
}

.search-input {
    padding-left: 38px;
    padding-right: 32px;
    border-radius: var(--radius-full);
    background: var(--sci-bg-subtle);
    border-color: var(--sci-border);
}

.search-input:focus {
    background: #ffffff;
}

.clear-search {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    font-size: 1.1rem;
    color: var(--sci-text-subtle);
    cursor: pointer;
}

/* Bento Asymmetric Grid */
.bento-menu-grid {
    display: grid;
    grid-template-columns: 1fr 380px;
    gap: 24px;
    align-items: start;
}

@media (max-width: 1100px) {
    .bento-menu-grid {
        grid-template-columns: 1fr;
    }
    .editor-column {
        order: -1;
    }
}

/* Cards */
.sci-card {
    background: var(--sci-surface);
    border: 1px solid var(--sci-border);
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-card);
    overflow: hidden;
}

.catalogue-card {
    padding: 0;
}

.card-header-bar {
    padding: 18px 24px;
    border-bottom: 1px solid var(--sci-border);
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.card-title {
    font-size: 1.15rem;
    font-weight: 700;
    color: var(--sci-text-main);
    margin: 0;
}

/* Catalogue Table */
.sci-table {
    width: 100%;
    border-collapse: collapse;
}

.sci-table th {
    background: var(--sci-bg-subtle);
    color: var(--sci-text-subtle);
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    padding: 12px 18px;
    border-bottom: 1px solid var(--sci-border);
    text-align: left;
}

.dish-row {
    border-bottom: 1px solid var(--sci-border);
    cursor: pointer;
    transition: background 0.15s ease;
}

.dish-row:hover {
    background: var(--sci-bg-subtle);
}

.dish-row.is-selected {
    background: var(--sci-primary-subtle);
    border-left: 4px solid var(--sci-primary);
}

.dish-row.is-hidden-dish {
    opacity: 0.65;
}

.sci-table td {
    padding: 14px 18px;
    vertical-align: middle;
}

/* Dish Elements */
.dish-thumb-box {
    width: 44px;
    height: 44px;
    border-radius: var(--radius-sm);
    overflow: hidden;
    background: var(--sci-bg-subtle);
    border: 1px solid var(--sci-border);
    display: flex;
    align-items: center;
    justify-content: center;
}

.dish-thumb-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.dish-thumb-placeholder {
    color: var(--sci-text-subtle);
    font-size: 1rem;
}

.dish-name-cell {
    max-width: 280px;
}

.dish-name-text {
    font-size: 0.95rem;
    color: var(--sci-text-main);
}

.dish-desc-text {
    font-size: 0.8rem;
    color: var(--sci-text-subtle);
    margin-top: 2px;
}

.badge-hidden {
    background: #e2e8f0;
    color: #475569;
    font-size: 0.65rem;
    font-weight: 700;
    padding: 2px 6px;
    border-radius: 4px;
    letter-spacing: 0.5px;
}

.badge-portata {
    display: inline-block;
    padding: 3px 10px;
    border-radius: var(--radius-full);
    font-size: 0.75rem;
    font-weight: 700;
    background: #e0e7ff;
    color: #3730a3;
    text-transform: capitalize;
}

.portata-antipasti { background: #fef3c7; color: #92400e; }
.portata-primi { background: #fee2e2; color: #991b1b; }
.portata-secondi { background: #dbeafe; color: #1e40af; }
.portata-contorni { background: #dcfce7; color: #166534; }
.portata-pizza { background: #ffedd5; color: #9a3412; }
.portata-dolci { background: #fce7f3; color: #9d174d; }
.portata-bevande { background: #e0f2fe; color: #075985; }

.price-tag {
    font-family: 'JetBrains Mono', monospace;
    font-size: 0.95rem;
    font-weight: 700;
    color: var(--sci-emerald);
}

.variations-summary {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
}

.var-badge {
    font-size: 0.7rem;
    font-weight: 700;
    padding: 2px 6px;
    border-radius: 4px;
}

.var-add {
    background: var(--sci-emerald-subtle);
    color: var(--sci-emerald-text);
}

.var-remove {
    background: var(--sci-rose-subtle);
    color: var(--sci-rose-text);
}

/* Editor Form Column */
.editor-column {
    position: sticky;
    top: 86px;
}

.editor-card {
    padding: 24px;
}

.editor-card-header {
    border-bottom: 1px solid var(--sci-border);
    padding-bottom: 16px;
    margin-bottom: 20px;
}

.form-group-sci {
    margin-bottom: 18px;
}

.form-label-sci {
    display: block;
    font-size: 0.85rem;
    font-weight: 600;
    color: var(--sci-text-main);
    margin-bottom: 6px;
}

.sci-input {
    width: 100%;
    min-height: var(--fitts-target-min);
    padding: 10px 14px;
    font-size: 0.95rem;
    border: 1px solid var(--sci-border);
    border-radius: var(--radius-md);
    background: var(--sci-surface);
    color: var(--sci-text-main);
    transition: all 0.2s ease;
    box-sizing: border-box;
}

.sci-input:focus {
    outline: none;
    border-color: var(--sci-primary);
    box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.15);
}

.sci-select {
    cursor: pointer;
}

.sci-textarea {
    resize: vertical;
    min-height: 80px;
}

.input-with-addon {
    position: relative;
    display: flex;
    align-items: center;
}

.input-addon {
    position: absolute;
    left: 14px;
    font-weight: 700;
    color: var(--sci-text-subtle);
}

.input-with-addon .sci-input {
    padding-left: 32px;
}

/* Switch */
.switch-box-sci {
    display: flex;
    align-items: center;
    gap: 12px;
    background: var(--sci-bg-subtle);
    padding: 12px 14px;
    border-radius: var(--radius-md);
    margin-bottom: 18px;
}

.switch-sci {
    position: relative;
    display: inline-block;
    width: 44px;
    height: 24px;
    flex-shrink: 0;
}

.switch-sci input {
    opacity: 0;
    width: 0;
    height: 0;
}

.slider-sci {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #cbd5e1;
    transition: 0.3s;
    border-radius: 24px;
}

.slider-sci:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: 0.3s;
    border-radius: 50%;
}

.switch-sci input:checked + .slider-sci {
    background-color: var(--sci-primary);
}

.switch-sci input:checked + .slider-sci:before {
    transform: translateX(20px);
}

.switch-label-sci {
    font-size: 0.85rem;
    cursor: pointer;
    margin: 0;
}

/* Photo Upload */
.image-preview-card {
    position: relative;
    width: 100%;
    height: 150px;
    border-radius: var(--radius-md);
    overflow: hidden;
    margin-bottom: 10px;
    border: 1px solid var(--sci-border);
}

.preview-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.btn-remove-photo {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: rgba(15, 23, 42, 0.7);
    color: #ffffff;
    border: none;
    cursor: pointer;
    font-size: 1.1rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.photo-upload-zone {
    border: 2px dashed var(--sci-border);
    border-radius: var(--radius-md);
    padding: 16px;
    text-align: center;
    cursor: pointer;
    background: var(--sci-bg-subtle);
    transition: all 0.2s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
}

.photo-upload-zone:hover {
    border-color: var(--sci-primary);
    background: var(--sci-primary-subtle);
}

.upload-icon {
    font-size: 1.5rem;
    color: var(--sci-primary);
}

.upload-text {
    font-size: 0.85rem;
    font-weight: 600;
    color: var(--sci-text-muted);
}

/* Variations Buttons */
.variations-actions-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    margin-bottom: 20px;
}

/* Actions Stack */
.editor-actions-stack {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 10px;
}

.btn-save {
    min-height: 48px;
    font-size: 1rem;
    font-weight: 700;
}

/* Buttons */
.sci-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: var(--fitts-target-min);
    padding: 10px 18px;
    border-radius: var(--radius-md);
    font-size: 0.9rem;
    font-weight: 600;
    cursor: pointer;
    border: 1px solid transparent;
    transition: all 0.2s ease;
    text-decoration: none;
    box-sizing: border-box;
}

.sci-btn-primary {
    background: var(--sci-primary);
    color: #ffffff;
}

.sci-btn-primary:hover {
    background: var(--sci-primary-hover);
    box-shadow: 0 4px 12px rgba(79, 70, 229, 0.25);
}

.sci-btn-secondary {
    background: var(--sci-bg-subtle);
    color: var(--sci-text-main);
    border-color: var(--sci-border);
}

.sci-btn-secondary:hover {
    background: #e2e8f0;
}

.sci-btn-danger {
    background: var(--sci-rose);
    color: #ffffff;
}

.sci-btn-danger:hover {
    background: #be123c;
}

.sci-btn-ghost {
    background: transparent;
    color: var(--sci-text-muted);
}

.sci-btn-ghost:hover {
    background: var(--sci-bg-subtle);
    color: var(--sci-text-main);
}

.sci-btn-outline-primary {
    background: #ffffff;
    color: var(--sci-primary);
    border-color: var(--sci-primary-border);
}

.sci-btn-outline-primary:hover {
    background: var(--sci-primary-subtle);
}

.sci-btn-outline-danger {
    background: #ffffff;
    color: var(--sci-rose);
    border-color: var(--sci-rose-border);
}

.sci-btn-outline-danger:hover {
    background: var(--sci-rose-subtle);
}

.btn-icon {
    width: 36px;
    height: 36px;
    min-height: 36px;
    padding: 0;
    border-radius: var(--radius-sm);
}

/* Modals */
.sci-modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(15, 23, 42, 0.6);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    z-index: 1050;
}

.sci-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1060;
    padding: 20px;
    box-sizing: border-box;
}

.sci-modal-dialog {
    width: 100%;
    max-width: 560px;
}

.sci-modal-card {
    background: #ffffff;
    border-radius: var(--radius-xl);
    box-shadow: var(--shadow-popover);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    max-height: 85vh;
}

.sci-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    border-bottom: 1px solid var(--sci-border);
    background: #ffffff;
}

.sci-btn-close {
    background: none;
    border: none;
    font-size: 1.5rem;
    color: var(--sci-text-subtle);
    cursor: pointer;
    line-height: 1;
}

.sci-modal-search {
    position: relative;
    padding: 12px 24px;
    background: var(--sci-bg-subtle);
    border-bottom: 1px solid var(--sci-border);
}

.sci-modal-search .search-icon {
    left: 36px;
}

.sci-modal-body {
    padding: 20px 24px;
    overflow-y: auto;
}

.touch-option-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
}

@media (max-width: 540px) {
    .touch-option-grid {
        grid-template-columns: 1fr;
    }
}

.touch-option-card {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    border: 1px solid var(--sci-border);
    border-radius: var(--radius-md);
    cursor: pointer;
    transition: all 0.15s ease;
    background: var(--sci-surface);
}

.touch-option-card:hover {
    border-color: var(--sci-primary-border);
    background: var(--sci-primary-subtle);
}

.touch-option-card.is-checked {
    border-color: var(--sci-primary);
    background: var(--sci-primary-subtle);
}

.touch-option-card.is-minus.is-checked {
    border-color: var(--sci-rose);
    background: var(--sci-rose-subtle);
}

.sci-checkbox {
    width: 18px;
    height: 18px;
    accent-color: var(--sci-primary);
    cursor: pointer;
}

.option-details {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
}

.option-name {
    font-size: 0.85rem;
    font-weight: 600;
    color: var(--sci-text-main);
}

.option-price {
    font-size: 0.8rem;
    font-weight: 700;
    color: var(--sci-emerald);
}

.sci-modal-footer {
    padding: 16px 24px;
    border-top: 1px solid var(--sci-border);
    background: var(--sci-bg-subtle);
}

.empty-state {
    padding: 60px 20px;
    text-align: center;
}

.empty-icon {
    font-size: 2.5rem;
    color: var(--sci-text-subtle);
    margin-bottom: 12px;
}
</style>
